import { useState } from "react";
import { FaThumbsUp, FaThumbsDown, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';

export default function ReviewPage() {
    const navigate = useNavigate();
    const [hover, setHover] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const screenshots = [
        "/reviews/review1.png",
        "/reviews/review2.png",
        "/reviews/review3.png"
    ];
  
    const handleReview = (positive) => {
      if (positive) {
        window.open("https://www.trustpilot.com/review/aihairstylestudio.com", "_blank");
      } else {
        navigate("/contact");
      }
    };

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % screenshots.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + screenshots.length) % screenshots.length);
    };

    const features = [
    {
      title: "AI Hairstyle Review",
      description: "Read reviews of AI Hairstyle Studio and see what users say about their virtual hair transformations!"
    },
    {
      title: "User Review",
      description: "Discover how AI-powered styling helps you try on different hairstyles, haircuts, and colors effortlessly"
    }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "AI Hairstyle Reviews",
    "description": "Read reviews of AI Hairstyle Studio and see what users say about their virtual hair transformations! Discover how AI-powered styling helps you try on different hairstyles, haircuts, and colors effortlessly.",
    "applicationCategory": "Hairstyles",
    "url": "https://www.aihairstylestudio.com/ai-hairstyle-reviews",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "featureList": features.map(f => f.title).join(", ")
  };

  
    return (
        <>
        <Helmet>
        <title>AI Hairstyle Reviews</title>
        <meta name="description" content="Read reviews of AI Hairstyle Studio and see what users say about their virtual hair transformations! Discover how AI-powered styling helps you try on different hairstyles, haircuts, and colors effortlessly." />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <div className="flex flex-col justify-center items-center min-h-screen w-full bg-gradient-to-b from-teal-300 to-teal-600 text-center p-4 pt-16 overflow-hidden"> {/* Added top padding */}
        <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-4 md:mb-6">AI Hairstyle Reviews - Rate Your Look</h1>
        <p className="text-lg md:text-xl text-gray-100 mb-4 md:mb-6 max-w-2xl px-2 md:px-0">
          Love your <a className="text-teal-600 hover:text-teal-500" href="https://www.aihairstylestudio.com">AI hairstyle changer?</a> Rate it now! We strive to give you the best hairstyle experience. Share your thoughts and help us improve! Your review helps others find their perfect style. Quick, simple, impactful.
        </p>
        
        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8 mt-6">
          <button
            onClick={() => handleReview(true)}
            onMouseEnter={() => setHover("up")}
            onMouseLeave={() => setHover(null)}
            className="btn flex items-center space-x-3 px-6 md:px-10 py-4 md:py-5 text-lg md:text-xl rounded-2xl transition-transform transform hover:scale-110 shadow-xl bg-white text-teal-600 hover:bg-teal-100 w-full md:w-auto"
          >
            <FaThumbsUp size={28} className={hover === "up" ? "text-teal-600 scale-125" : "text-teal-600"} />
            <span className="font-bold">Absolutely Love It!</span>
          </button>
          <button
            onClick={() => handleReview(false)}
            onMouseEnter={() => setHover("down")}
            onMouseLeave={() => setHover(null)}
            className="btn flex items-center space-x-3 px-6 md:px-10 py-4 md:py-5 text-lg md:text-xl rounded-2xl transition-transform transform hover:scale-110 shadow-xl bg-gray-800 text-white hover:bg-gray-700 w-full md:w-auto"
          >
            <FaThumbsDown size={28} className={hover === "down" ? "text-white scale-125" : "text-white"} />
            <span className="font-bold">Needs Some Work</span>
          </button>
        </div>
        <p className="mt-6 md:mt-8 text-base md:text-lg text-gray-200 px-2 text-center">
          Your feedback helps us innovate and enhance your styling experience. Thank you! 💖
        </p>

        {/* Slideshow Section */}
        <div className="w-full max-w-3xl mt-16 relative flex items-center justify-center"> {/* Increased top margin */}
          <button onClick={prevSlide} className="absolute left-0 z-10 p-2 text-white bg-gray-700 rounded-full shadow-md hover:bg-gray-600"> 
            <FaChevronLeft size={24} /> 
          </button>
          <div className="w-full max-w-xl h-96 flex justify-center items-center"> {/* Fixed dimensions */}
            <img src={screenshots[currentIndex]} alt={`Review screenshot ${currentIndex + 1}`} className="w-full h-full object-contain rounded-lg shadow-lg" />
          </div>
          <button onClick={nextSlide} className="absolute right-0 z-10 p-2 text-white bg-gray-700 rounded-full shadow-md hover:bg-gray-600"> 
            <FaChevronRight size={24} /> 
          </button>
        </div>
      </div>
            </>
    );
}
